<template>
	<div>
		<template v-if="hasResults">
			<div
				v-for="structuredGoals in structures"
				:key="structuredGoals.sourceId"
				class="mt-4"
			>
				<template v-if="structuredGoals.items.length">
					<h1 v-if="structures.length > 1" class="text-2xl font-bold mb-4">
						{{ structuredGoals.name }}
					</h1>

					<div
						v-for="lev1item in structuredGoals.items"
						:key="lev1item.uniquePath ?? goalKey(lev1item.goal)"
						id="goal-list"
						class="goal-list mb-2"
					>
				<template v-if="lev1item.items">
					<h1 :style="{ color: getListItemColor(lev1item) }" class="sticky top-0">
						<span class="path" :style="{ backgroundColor: getListItemColor(lev1item) }">{{
							lev1item.path
						}}</span>
						{{ lev1item.title }}
					</h1>
					<ol :id="getGroupId(lev1item)">
						<template v-if="!lev1item.items">
							<GoalListItem
								:listItem="lev1item"
								:action="action"
								:checked="checkedFunction(lev1item.goal)"
								@[propagatedEventChecked]="itemChecked"
								@[propagatedEventUnchecked]="itemUnchecked"
								@[propagatedEventRequestEdit]="editRequested"
								@[propagatedEventRequestRemoval]="removalRequested"
							/>
						</template>

						<li
							v-else
							v-for="lev2item in lev1item.items"
							:key="lev2item.path ?? goalKey(lev2item.goal)"
							:class="[lev2item.items ? '' : 'border-l-2']"
							:style="{ borderColor: getListItemColor(lev1item) }"
						>
							<template v-if="lev2item.items">
								<h2 :style="{ color: getListItemColor(lev1item) }" class="sticky top-6">
									<span class="path" :style="{ backgroundColor: getListItemColor(lev1item) }">{{
										lev2item.path
									}}</span>
									{{ lev2item.title }}
								</h2>
								<button
									v-if="action === 'import'"
									type="button"
									class="btn-select-all mb-2"
									@click="selectAllByGroupId(getGroupId(lev2item))"
								>
									{{ $t("(De)select all") }}
								</button>
								<ol :id="getGroupId(lev2item)">
									<li
										v-for="lev3item in lev2item.items"
										:key="lev3item.path ?? goalKey(lev3item.goal)"
										:class="[lev3item.items ? '' : 'border-l-2']"
										:style="{ borderColor: getListItemColor(lev1item) }"
									>
										<template v-if="lev3item.items">
											<h3 :style="{ color: getListItemColor(lev1item) }" class="sticky top-12">
												<span
													class="path"
													:style="{ backgroundColor: getListItemColor(lev1item) }"
													>{{ lev3item.path }}</span
												>
												{{ lev3item.title }}
											</h3>
											<button
												v-if="action === 'import'"
												type="button"
												class="btn-select-all"
												@click="selectAllByGroupId(getGroupId(lev3item))"
											>
												{{ $t("(De)select all") }}
											</button>
											<ol :id="getGroupId(lev3item)">
												<li
													v-for="lev4item in lev3item.items"
													:key="lev4item.path ?? goalKey(lev4item.goal)"
													:class="[lev4item.items ? '' : 'border-l-2']"
													:style="{ borderColor: getListItemColor(lev1item) }"
												>
													<template v-if="lev4item.items">
														<h4 :style="{ color: getListItemColor(lev1item) }">
															<span
																class="path"
																:style="{ backgroundColor: getListItemColor(lev1item) }"
																>{{ lev4item.path }}</span
															>
															{{ lev4item.title }}
														</h4>
														<button
															v-if="action === 'import'"
															type="button"
															class="btn-select-all"
															@click="selectAllByGroupId(getGroupId(lev4item))"
														>
															{{ $t("(De)select all") }}
														</button>
														<ol :id="getGroupId(lev4item)">
															<li
																v-for="lev5item in lev4item.items"
																:key="lev5item.path ?? goalKey(lev5item.goal)"
																:class="[lev5item.items ? '' : 'border-l-2']"
																:style="{ borderColor: getListItemColor(lev1item) }"
															>
																<GoalListItem
																	:listItem="lev5item"
																	:action="action"
																	:style="{color: getListItemColor(lev1item)}"
																	:checked="checkedFunction(lev5item.goal)"
																	:changed="changedFunction(lev5item.goal)"
																	@[propagatedEventChecked]="itemChecked"
																	@[propagatedEventUnchecked]="itemUnchecked"
																	@[propagatedEventRequestEdit]="editRequested"
																	@[propagatedEventRequestRemoval]="removalRequested"
																/>
															</li>
														</ol>
													</template>
													<GoalListItem
														v-else
														:listItem="lev4item"
														:action="action"
														:checked="checkedFunction(lev4item.goal)"
														:changed="changedFunction(lev4item.goal)"
														@[propagatedEventChecked]="itemChecked"
														@[propagatedEventUnchecked]="itemUnchecked"
														@[propagatedEventRequestEdit]="editRequested"
														@[propagatedEventRequestRemoval]="removalRequested"
													/>
												</li>
											</ol>
										</template>
										<GoalListItem
											v-else
											:listItem="lev3item"
											:action="action"
											:checked="checkedFunction(lev3item.goal)"
											:changed="changedFunction(lev3item.goal)"
											@[propagatedEventChecked]="itemChecked"
											@[propagatedEventUnchecked]="itemUnchecked"
											@[propagatedEventRequestEdit]="editRequested"
											@[propagatedEventRequestRemoval]="removalRequested"
										/>
									</li>
								</ol>
							</template>
							<GoalListItem
								v-else
								:listItem="lev2item"
								:action="action"
								:checked="checkedFunction(lev2item.goal)"
								:changed="changedFunction(lev2item.goal)"
								@[propagatedEventChecked]="itemChecked"
								@[propagatedEventUnchecked]="itemUnchecked"
								@[propagatedEventRequestEdit]="editRequested"
								@[propagatedEventRequestRemoval]="removalRequested"
							/>
						</li>
					</ol>
				</template>
				<GoalListItem
					v-else
					:listItem="lev1item"
					:action="action"
					:checked="checkedFunction(lev1item.goal)"
					:changed="changedFunction(lev1item.goal)"
					@[propagatedEventChecked]="itemChecked"
					@[propagatedEventUnchecked]="itemUnchecked"
					@[propagatedEventRequestEdit]="editRequested"
					@[propagatedEventRequestRemoval]="removalRequested"
				/>
					</div>
				</template>
			</div>
		</template>

		<div v-else-if="!store.loading">
			<p class="text-base-content-light pt-4 italic text-center">{{ $tc("Results", 0) }}</p>
		</div>

		<div v-else class="text-center">
			<span class="loading loading-spinner loading-lg"></span>
		</div>

	</div>
</template>

<script lang="ts">
import GoalListItem from "@/components/GoalListItem.vue";
import { PopulatedGoalStructureContent, PopulatedGoalStructureContentItem } from "@/utils/GoalSource";

export default {
	emits: ["item-checked", "item-unchecked", "request-edit", "request-removal"],

	props: {
		action: {
			type: String,
			default: "select",
			validates: (value) => ["edit", "import", "select"].includes(value),
		},
		checkedFunction: {
			type: Function,
			default: () => false,
		},

		changedFunction: {
			type: Function,
			default: () => false,
		},

		store: null,
	},

	data() {
		return {};
	},

	components: {
		GoalListItem,
	},

	computed: {
		// The store always exposes an array of populated structures (one per source).
		structures(): PopulatedGoalStructureContent[] {
			return this.store?.structuredGoals ?? [];
		},
		hasResults(): boolean {
			return this.structures.some((s) => s.items && s.items.length > 0);
		},

		// Below computed properties are used to conditionally emit events
		propagatedEventChecked() {
			return this.action === "select" || this.action === "import" ? "checked" : null;
		},
		propagatedEventUnchecked() {
			return this.action === "select" || this.action === "import" ? "unchecked" : null;
		},
		propagatedEventRequestEdit() {
			return this.action === "edit" ? "request-edit" : null;
		},
		propagatedEventRequestRemoval() {
			return this.action === "edit" ? "request-removal" : null;
		},
	},

	rgbColorMap: new Map(),

	methods: {
		itemChecked(item) {
			this.$emit("item-checked", item);
		},
		itemUnchecked(item) {
			this.$emit("item-unchecked", item);
		},
		editRequested(item) {
			this.$emit("request-edit", item);
		},
		removalRequested(item) {
			this.$emit("request-removal", item);
		},

		/**
		 * v-for key for a goal row. fullPath alone is not unique: every subgoal of one goal
		 * shares its parent's path ('NL.003.x'), so siblings would collide and Vue could
		 * patch the wrong row. Persisted goals have an id; picked-but-unsaved ones still
		 * carry their curriculum's source id.
		 */
		goalKey(goal: any): string {
			return goal.id || goal.sourceId || goal.fullPath;
		},

		/**
		 * Generate a unique DOM ID for a group element, based on the item's uniquePath
		 * (which includes the source ID to prevent collisions across sources).
		 */
		getGroupId(item: PopulatedGoalStructureContentItem): string {
			const path = item.uniquePath ?? item.path;
			return `group-${path.replaceAll('.', '-').replaceAll(':', '_')}`;
		},

		selectAllByGroupId(groupId: string) {
			let checkboxElements = Array.from(
				document.querySelectorAll(`#${groupId} input[type="checkbox"]:not(:disabled)`)
			);

			const notChecked = (checkbox) => !checkbox.checked;

			if (checkboxElements.some(notChecked)) {
				checkboxElements.forEach((checkbox) => {
					if (!checkbox.checked) {
						checkbox.checked = true;
						checkbox.dispatchEvent(new Event("change"));
					}
				});
			} else {
				checkboxElements.forEach((checkbox) => {
					if (checkbox.checked) {
						checkbox.checked = false;
						checkbox.dispatchEvent(new Event("change"));
					}
				});
			}

			checkboxElements = null;
		},

		getListItemColor(item: PopulatedGoalStructureContentItem) {
			if (!item.color) {
				return "#818cf8"; // Default color if not specified (indigo-400 / accent-focus)
			}
			return item.color;
		},
	},
};
</script>
